import { useCallback, useRef, useEffect } from 'react';

export function useAnnounce() {
  const regionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const region = document.createElement('div');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.className = 'sr-only';
    document.body.appendChild(region);
    regionRef.current = region;
    return () => { document.body.removeChild(region); };
  }, []);

  const announce = useCallback((message: string, priority: 'polite' | 'assertive' = 'polite') => {
    if (!regionRef.current) return;
    regionRef.current.setAttribute('aria-live', priority);
    regionRef.current.textContent = '';
    requestAnimationFrame(() => { if (regionRef.current) regionRef.current.textContent = message; });
  }, []);

  return announce;
}
